import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20editorial%20collage%20of%20abstract%20organic%20shapes%20in%20sage%20green%2C%20warm%20terracotta%20and%20amber%20gold%2C%20gentle%20flowing%20waves%20and%20overlapping%20translucent%20forms%20on%20a%20deep%20warm%20neutral%20base%2C%20airy%20minimal%20premium%20aesthetic%2C%20high%20key%20gradient%20lighting%2C%20no%20text%2C%20no%20people&width=1600&height=700&seq=usfans-hero-02&orientation=landscape&nocache=true"
          alt="USFans Spreadsheet resource hub background"
          title="USFans Spreadsheet resource hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/55 via-background-950/35 to-background-950/55" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-4 md:px-6 py-20 md:py-28 text-center w-full">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-sm font-medium backdrop-blur-sm whitespace-nowrap">
          {t("hero.eyebrow")}
        </span>
        <h1 className="mt-6 font-heading font-semibold text-3xl md:text-5xl leading-tight text-background-50">
          {t("hero.title")}
        </h1>
        <p className="mt-5 text-base md:text-lg text-background-50/90 max-w-2xl mx-auto leading-relaxed">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-links-line text-lg" />
            {t("hero.ctaPrimary")}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-foreground-950 font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg" />
            {t("hero.ctaSecondary")}
          </a>
        </div>

        <p className="mt-6 text-sm text-background-50/80">{t("hero.trust")}</p>
      </div>
    </section>
  );
}